import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingOverlay from 'src/shared/components/organisms/loadingOverlay';
import { AutogiroReminderSettings, AutogiroRemindersSettings } from 'src/shared/components/organisms/autogiroRemindersSettings';
import {
  FailedAutogiroPaymentMailSettings,
  FailedAutogiroPaymentMailValues,
} from 'src/shared/components/organisms/failedAutogiroPaymentMailSettings';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { InvoiceGroup } from 'src/shared/models/invoiceGroup/invoiceGroup';
import { getInvoiceGroupById, updateInvoiceGroup } from 'src/shared/services/invoiceGroupService';

// Platshållare som kan användas i ämne och text för påminnelserna.
// Medlemspåminnelsen (SendEmailRemindersForAutogiromandateMember) fyller bara i namn och signeringslänk.
const reminderCustomFields = [
  { label: 'Namn', value: '[name]' },
  { label: 'Signeringslänk', value: '[signingLink]' },
];

// Platshållare för mailen vid misslyckad dragning. Beloppet och betalningslänken fylls i av
// autojobbet, orsaken kommer ordagrant från Bankgirot.
const failedPaymentCustomFields = [
  { label: 'Namn', value: '[name]' },
  { label: 'Belopp', value: '[amount]' },
  { label: 'OCR', value: '[ocr]' },
  { label: 'Orsak', value: '[reason]' },
  { label: 'Betalningslänk', value: '[payLink]' },
];

export const AdminInvoiceGroupAutogiroRemindersTab = () => {
  const { id } = useParams();
  const isMounted = useIsMounted();
  const [loading, setLoading] = useState(true);
  const [invoiceGroup, setInvoiceGroup] = useState<InvoiceGroup>();

  useEffect(() => {
    if (!id) return;

    const fetchInvoiceGroup = async () => {
      setLoading(true);
      try {
        const result = await getInvoiceGroupById(+id);
        if (isMounted()) setInvoiceGroup(result.data);
      } catch (err) {
        if (isMounted()) ConsoleHelper.log(err);
      } finally {
        if (isMounted()) setLoading(false);
      }
    };

    fetchInvoiceGroup();
  }, [id, isMounted]);

  // PUT på fakturagruppen ersätter hela posten, så övriga fält skickas med oförändrade.
  const save = async (settings: AutogiroReminderSettings | FailedAutogiroPaymentMailValues) => {
    if (!invoiceGroup) return;
    const updated = { ...invoiceGroup, ...settings };
    await updateInvoiceGroup(updated);
    if (isMounted()) setInvoiceGroup(updated);
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <LoadingOverlay loading={loading} />
      {!loading && invoiceGroup && (
        <Grid container>
          <AutogiroRemindersSettings
            initialValues={invoiceGroup}
            customFields={reminderCustomFields}
            assemblyName='SendEmailRemindersForAutogiromandateMember'
            translationPrefix='invoice:autogiroReminders'
            onSave={save}
          />
          <FailedAutogiroPaymentMailSettings
            initialValues={invoiceGroup}
            customFields={failedPaymentCustomFields}
            translationPrefix='invoice:failedAutogiroPaymentMail'
            onSave={save}
          />
        </Grid>
      )}
    </Box>
  );
};
